import "./style.css";
import { DeleteOutlined } from "@ant-design/icons";
import { Table } from "antd";
import type { TableProps } from "antd";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Drawer from "../../components/ui/drawer";
import Directories from "../../components/directories";
import { FormContext } from "../../contexts/form/index.context";
import { TableContext } from "../../contexts/table/index.context";
import { useRowsTable } from "../resolutionsContext/resolutionCtx";
import { Popconfirm } from 'antd';

import { SessionContext } from "../../contexts/session/index.context";
import { TranslationContext } from "../../contexts/translation/index.context";

import { request } from "../../services";


import {
  makeColumns,
  DATE_FMT,
  Row,
  PatchRow,
  actionMemoryS
} from "./columns/columns";

import dayjs from "dayjs";

type ActionOption = { value: number; label: string};

export default function TableResolutions({userID, action, date }: any) {
  const { intl } = useContext(TranslationContext);

  const { sessionData } = useContext(SessionContext);

  const { rowData } = useContext(TableContext);
  const { form } = useContext(FormContext);
  const {rowsTable, rowsTable2, setRowsTable, setRowsTable2, setFullList} = useRowsTable();

  const [temporaryTable, setTemporaryTable] = useState<Row[]>([]);
  const [temporaryAddedPerformers, setTemporaryAddedPerformers] = useState<Row[]>([]);

  const [dateMemory, setDateMemory] = useState<string>("");
  const [actionMemory, setActionMemory] = useState<ActionOption | null>(null);

  const [selectedRow, setSelectedRow] = useState<Row>();
  const [selectedKey, setSelectedKey] = useState<React.Key>();
  // const [selectedRowFull, setSelectedRowFull] = useState<Row>();

  // === patchRow тут, має доступ до стейтів ===
  const patchRow: PatchRow = useCallback((id, patch) => {
    setTemporaryTable((prev) => prev.map((r) => (r.id === id ? { ...r, ...patch } : r)));
    setTemporaryAddedPerformers((prev) =>
      prev.map((r) => (r.id === id ? { ...r, ...patch } : r))
    );
  }, []);

useEffect(() => {
  if (!temporaryTable || temporaryTable.length === 0) {
    setSelectedKey(undefined);
    return;
  }

  // 1) шукаємо вже позначеного головного
  const main = temporaryTable.find(r => r.isMainExecutors === 1);

  if (main) {
    // якщо вже є — просто синхронізуємо radio
    if (selectedKey !== main.id) setSelectedKey(main.id);
    return;
  }

  // 2) якщо немає — вибираємо першого
  const firstId = temporaryTable[0].id;
  if (selectedKey !== firstId) setSelectedKey(firstId);

  // 3) і ОДНОРАЗОВО оновлюємо дані: робимо першого головним
  //    захист від зайвого сету: міняємо лише якщо перший ще не 1
  if (temporaryTable[0].isMainExecutors !== 1) {
    setTemporaryTable(prev =>
      prev.map(r => ({ ...r, isMainExecutors: r.id === firstId ? 1 : 0 }))
    );
  }
}, [temporaryTable]);

  const columns = useMemo(() => makeColumns(patchRow, intl), [patchRow, intl]);

const rowSelection: TableProps<Row>["rowSelection"] = {
  type: "radio",
  columnTitle: <span>{intl("main-exec-table")}</span>,
  columnWidth: 90,
  selectedRowKeys: selectedKey ? [selectedKey] : [],
  
  onChange: (keys, rows) => {
    const key = keys[0] as React.Key | undefined;
    setSelectedKey(key);

    // оновлюємо прапорці в таблиці: лише вибраний має 1, інші 0
    setTemporaryTable(prev =>
      prev.map(r => ({
        ...r,
        isMainExecutors: r.id === key ? 1 : 0,
      }))
    );
  },
};

  function setFormFields() {
    if (!rowData) return;

    const pickedWrap = rowData["/directories/employees-and-contact-persons"];
    if (!pickedWrap?.data) return;
    const picked = pickedWrap.data;
// console.log("ADD  picked ", picked)

    form.setFieldsValue({ emplAndContact: picked.contact_person_Own });

    const newRow: Row = {
      ...picked,
      key: picked.id,
      Executors_FIO_name: picked.contact_person,
      Executors_FIO_id: picked.exec_fio_id,
      name_actions_doc: actionMemory?.label ?? "",
      eta_actions_doc_id: actionMemory?.value ?? null,
      dateK_plan: dayjs(dateMemory, ["DD.MM.YYYY", "DD-MM-YYYY"]) ?? null,
      parent_id: null,
      isMainExecutors: 0,
      Controllers_id: sessionData.Executors_FIO_id,
      user_id: userID,
      Executor_type: picked.typerec,
      Executors_id: picked.exec_id,
      idNewRow: null,
    };

    setTemporaryAddedPerformers((prev) =>
      prev.some((r) => r.id === newRow.id) ? prev : [...prev, newRow]
    );

    setTemporaryTable((prev) =>
      prev.some((r) => r.id === newRow.id) ? prev : [...prev, newRow]
    );

  }

    useEffect(() => {
    // console.log("temporaryTable LIST  === ", temporaryTable);
    setFullList(temporaryTable);
  }, [temporaryTable, setFullList, setTemporaryTable]);

  useEffect(() => {
    if(rowsTable.length === 0) return;
    // console.log("NEW LIST rowsTable === ", rowsTable);

    const map = new Map(temporaryTable.map(item => [item.id, item]));

    for (const item of rowsTable) {
      if (!map.has(item.id)) map.set(item.id, item);
    }

    const fullList: Row[] = Array.from(map.values());
    // console.log("fullList fullList 1", fullList);

    setTemporaryTable(fullList);
    setRowsTable([]);
  }, [rowsTable]);



  useEffect(() => {
    if(rowsTable2.length === 0) return;
    // console.log("NEW LIST rowsTable2 === ", rowsTable2);

    const map = new Map(temporaryTable.map(item => [item.id, item]));

    for (const item of rowsTable2) {
      if (!map.has(item.id)) map.set(item.id, item);
    }

    const fullList: Row[] = Array.from(map.values());

    console.log("fullList fullList 2", fullList);
    setTemporaryTable(fullList);
    setRowsTable2([]);
  }, [rowsTable2]);

  useEffect(() => {
// console.log("ACTION TEST ", action)
    if(dateMemory !== date) setDateMemory("");
    if(actionMemory?.value !== action?.id) setActionMemory(null);
    // if(actionMemory?.value !== action?.id) actionMemoryS(null);

    const dateStr = typeof date === "string" ? date : date?.format?.("DD.MM.YYYY") ?? "";
    setDateMemory(dateStr);
    setActionMemory(action);
    // actionMemoryS(action);

    // setTemporaryAddedPerformers((prev) =>
    //   prev.map((r) => ({
    //     ...r,
    //     name_actions_doc: action?.label ?? r.name_actions_doc,
    //     // dateK_plan: r.dateK_plan || "",
    //     // dateK_plan: dateStr || r.dateK_plan,
    //   }))
    // );
  }, [action, date]);

  useEffect(() => {
    if (temporaryAddedPerformers.length === 0) return;
    const byId = new Map(temporaryAddedPerformers.map((r) => [r.id, r]));
    setTemporaryTable((prev) =>
      prev.map((r) => (byId.has(r.id) ? { ...r, ...byId.get(r.id)! } : r))
    );
  }, [temporaryAddedPerformers]);

  type DeletePayload = {
  id_parent: number;         
  list_id_del: string;           
};

    async function deleteQuery(data: DeletePayload) {
      const content = (
        await request(`/documents/resolutions/deletetemporaryrows`, {
          method: "post",
          body: {
            id_parent: data.id_parent,
            list_id_del: data.list_id_del,
          },
          cancelTokenKey: "deleteteprows",
        })
      ); 
      // console.log("CONTENT AFTER DELETE", content);

    if (!content) {
      console.error("Network/unknown error");
      return { success: false, error: "Network error" };
  }

    if (!content.success) {
      console.error("Server error:", content.error);
      return content;
  }
      return content;
    };




  const deleteRow = async (data: Row | undefined) => {
    if(!data){
      return;
    }
    const delInfo: DeletePayload = {
      id_parent: data.parent_id,
      list_id_del: data.id.toString(),
    }
    const response = await deleteQuery(delInfo);
    
    if(response && response.success) {
      setTemporaryTable(prev => prev.filter(r => r.key !== data.id));
    }
  };


  return (
    <div className="resolutions_table_temporary">
      <div className="btn_wrapper_temporary">
        <Drawer
          hidden
          url="/directories/employees-and-contact-persons"
          setFormFields={setFormFields}
          fieldName="emplAndContact"
        >
          <Directories
            url="/directories/employees-and-contact-persons"
            selectedRowId={form.getFieldValue("contact_person_Own")}
          />
        </Drawer>

      <Popconfirm
        className="popconfirmStyle"
        title={intl("delete-row")}
        description={intl("cancel-action")}
        okText={intl("yes")}
        okButtonProps={{className: 'popOk'}}
        cancelText={intl("no")}
        cancelButtonProps={{className: 'popCancel'}}
        onConfirm={() => selectedRow && deleteRow(selectedRow)}
      >
        <DeleteOutlined className="btn_temporary"/>
        {/* <DeleteOutlined className="btn_temporary" onClick={() => selectedRow && deleteRow(selectedRow)}/> */}

      </Popconfirm>
      </div>

      <Table<Row>
        dataSource={temporaryTable}
        columns={columns}
        bordered
        pagination={false}
        size="small"
        scroll={{ x: "max-content" }}
        tableLayout="fixed"
        rowClassName={(record) => record.id === selectedRow?.id ? "clickable-row" : "style-row"}
        rowSelection={rowSelection}
        rowKey={(r) => r.id ?? r.key}
        onRow={(record) => ({
          onClick: () => {
            // setSelectedRowFull(record);
            setSelectedRow(record);
        },
        })}
      />
    </div>
  );
}
